import axios from "axios";
import { ROOT_URL } from "../../../config/url";
import type { WbStoresResponse, SyncKey } from "./wb-stores-types";

function getHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("tokenSession"),
  };
}

const api = axios.create({ baseURL: ROOT_URL, withCredentials: false });

export function getWbStores(params: {
  query?: string;
  sync_status?: string;
  page?: number;
  limit?: number;
}): Promise<WbStoresResponse> {
  return api
    .get("/api/admin/wb-stores", { headers: getHeaders(), params })
    .then((res) => res.data);
}

export function syncWbStore(connectionUuid: string, key: SyncKey): Promise<void> {
  const url = `/api/admin/wb-stores/${connectionUuid}/sync/${key}`;
  return api.post(url, undefined, { headers: getHeaders() }).then(() => undefined);
}

export interface StepResult {
  name: string;
  status: string; // "ok" | "error: <msg>" | "skipped"
  duration_ms?: number; // время выполнения шага в миллисекундах
}

export interface SyncStatusResponse {
  job_id?: number;
  job_type?: string;
  job_status?: string;
  current_step?: number;
  step_name?: string;
  started_at?: string;
  finished_at?: string;
  steps: StepResult[];
}

export const getWbSyncStatus = async (connectionUuid: string): Promise<SyncStatusResponse> => {
  return api
    .get(`/api/admin/wb-stores/${connectionUuid}/sync/status`, { headers: getHeaders() })
    .then((res) => res.data);
};

export const enqueueWbJob = async (
  connectionUuid: string,
  type: 'initial_sync' | 'daily_sync'
): Promise<{ job_id: number }> => {
  return api
    .post(`/api/admin/wb-stores/${connectionUuid}/jobs/enqueue`, { type }, { headers: getHeaders() })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.status === 409) throw new Error('CONFLICT');
      throw err;
    });
};
